/* eslint-disable react-native/no-inline-styles */
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  useWindowDimensions,
  ViewStyle,
  TextStyle,
  ImageStyle,
  Image,
  NativeSyntheticEvent,
  TextInputChangeEventData,
} from 'react-native';
import React, {useState} from 'react';
import {corner_radius, spacing} from 'theme/Units';
import {Button} from 'ui-kits/index';
import {colors} from 'theme/Colors';
import {mergeDeepRight} from 'ramda';
import {askQuestion} from 'services/api';
import {logFAQEvent} from 'services/firebase';
import {getSuccessMessage, getErrorMessage} from 'utils/getMessages';
import {SUCCESS_KEY, ERROR_KEY} from 'constants/keys';
import {useToast} from 'hooks';
import {staticDataForScreen} from 'constants/DefaultValues';

const {faqItems: QUESTIONS} = staticDataForScreen.landing_screen;

export function FAQ() {
  const [formData, setFormData] = useState({
    email: '',
    question: '',
  });
  const [error, setError] = useState({
    api: '',
    email: '',
    question: '',
  });

  // for displaying toastmessages
  const {showToasts} = useToast();

  const [expandedIndex, setExpandedIndex] = useState(0);

  const toggleAccordion = (index: any) => {
    setExpandedIndex(prevIndex => (prevIndex === index ? null : index));
  };

  function handleChange(value: string, name: keyof typeof formData) {
    setFormData(p => ({...p, [name]: value}));
  }

  let overrideStyle = structuredClone(baseStyles);
  const SCREEN_WIDTH = useWindowDimensions().width;

  // breakpoints and styles
  if (SCREEN_WIDTH < 1024) {
    overrideStyle.heading.fontSize = 48;
    overrideStyle.heading2.fontSize = 44;
  }
  if (SCREEN_WIDTH < 850) {
    overrideStyle.container.paddingHorizontal = spacing['12'];

    overrideStyle.questionContainer.gridTemplateRows = 'none';
    overrideStyle.questionContainer.gridTemplateColumns = 'none';
    overrideStyle.questionContainer.flexDirection = 'column-reverse';
    overrideStyle.questionContainer.display = 'flex';

    overrideStyle.questionForm.alignItems = 'center';
    overrideStyle.questionForm.paddingRight = 0;

    overrideStyle.questionForm.alignSelf = 'stretch';
    overrideStyle.heading2.alignSelf = 'stretch';
  }

  if (SCREEN_WIDTH < 720) {
    overrideStyle.heading.fontSize = 40;
    overrideStyle.heading2.fontSize = 36;
    overrideStyle.container.paddingHorizontal = spacing['10'];
  }
  if (SCREEN_WIDTH < 640) {
    overrideStyle.heading.fontSize = 32;
    overrideStyle.accordiaTitle.fontSize = 18;
    overrideStyle.accordiaDescription.fontSize = 14;
    overrideStyle.heading2.fontSize = 28;
    overrideStyle.container.paddingHorizontal = spacing['8'];
  }
  if (SCREEN_WIDTH < 480) {
    overrideStyle.heading2.fontSize = 24;
    overrideStyle.accordiaTitle.fontSize = 16;
    overrideStyle.accordiaDescription.fontSize = 12;
    overrideStyle.container.paddingHorizontal = spacing['6'];
  }
  if (SCREEN_WIDTH < 360) {
    overrideStyle.container.paddingHorizontal = spacing['4'];
  }

  function validateEmail() {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(formData.email);
  }

  /**
   * calls the api to submit the request for FAQ
   */
  async function handleSubmit() {
    /**
     * reset the error in the begining
     */
    setError({
      api: '',
      email: '',
      question: '',
    });
    /**
     * validate entries
     */

    // if no value passed for email, throw error
    if (formData.email === '') {
      setError(p => ({...p, email: 'email cannot be blank'}));
      return;
    }
    // if no value passed for question, throw error
    if (formData.question === '') {
      setError(p => ({...p, question: 'question cannot be blank'}));
      return;
    }

    // if values are passed, check if they are correct?

    if (!validateEmail()) {
      setError(p => ({...p, email: 'email provided is invalid!'}));
      return;
    }

    try {
      const response = await askQuestion(formData.email, formData.question);

      const {status, status_code} = response.data;
      if (status === SUCCESS_KEY) {
        // upon sucess
        showToasts(SUCCESS_KEY, getSuccessMessage(status_code), 'success');
        logFAQEvent(formData.email, formData.question);
      } else if (status === ERROR_KEY) {
        showToasts(ERROR_KEY, getErrorMessage(status_code), 'error');
      }
      setFormData({
        email: '',
        question: '',
      });
    } catch (err: any) {
      setError(p => ({...p, api: err?.message}));
      showToasts(ERROR_KEY, err?.message, 'error');
    }
  }

  const styles: styleType = mergeDeepRight(baseStyles, overrideStyle) as any;

  const downArrow: JSX.Element = (
    <Image
      source={require('assets/icons/cheveron_down@2x.png')}
      style={styles.arrowIcon}
    />
  );
  const upArrow: JSX.Element = (
    <Image
      source={require('assets/icons/cheveron_up@2x.png')}
      style={styles.arrowIcon}
    />
  );

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>Frequently Asked Questions</Text>

      {/* removed search bar, will be used for later*/}
      {/* <View style={styles.inputContainer}>
        <TextInput
          style={styles.input}
          placeholder="search for a question..."
          placeholderTextColor={styles.input.color}
          id="FAQ_input"
        />
        <Button
          text="search"
          variant="primary"
          style={styles.searchButton}
        />
      </View> */}

      {/* bottom container */}
      <View style={styles.questionContainer}>
        {/* ask questiom form */}
        <View style={styles.questionForm}>
          <Text style={styles.heading2}>
            Couldn't find what you are {'\n'}looking for?
          </Text>
          <View style={styles.formInputContainer}>
            <Text style={styles.errorLabel}>{error.email}</Text>
            <TextInput
              style={[
                styles.textarea,
                {
                  outline: error.email
                    ? `3px solid ${colors.palette.errorRed}`
                    : '1px solid transparent',
                },
              ]}
              onChange={(e: NativeSyntheticEvent<TextInputChangeEventData>) => {
                handleChange(e.nativeEvent.text, 'email');
              }}
              value={formData.email}
              placeholder="Enter your email address"
              placeholderTextColor={styles.input.color}
              id="FAQ_input"
            />
          </View>
          <View style={{...styles.formInputContainer, height: 110}}>
            <Text style={styles.errorLabel}>{error.question}</Text>
            <TextInput
              multiline={true}
              value={formData.question}
              onChange={(e: NativeSyntheticEvent<TextInputChangeEventData>) => {
                handleChange(e.nativeEvent.text, 'question');
              }}
              style={[
                styles.textarea,
                {
                  outline: error.question
                    ? `3px solid ${colors.palette.errorRed}`
                    : '1px solid transparent',
                },
              ]}
              placeholder="Ask Questions here..."
              placeholderTextColor={styles.input.color}
              id="FAQ_input"
            />
          </View>

          <Button
            variant={
              Boolean(formData.email && formData.question) && validateEmail()
                ? 'outline'
                : 'outlineDisabled'
            }
            text="Submit"
            disabled={
              !(Boolean(formData.email && formData.question) && validateEmail())
            }
            textStyle={styles.submitButtonText}
            style={styles.submitButton}
            onPress={handleSubmit}
          />
        </View>

        {/* question list */}
        <View style={styles.accordianContainer}>
          {QUESTIONS.map((item, index) => {
            const isExpanded = expandedIndex === index;
            return (
              <View style={styles.accordian} key={item.id}>
                <View style={styles.accordianTitleContainer}>
                  <Text style={styles.accordiaTitle}>{item.title}</Text>
                  <TouchableOpacity onPress={() => toggleAccordion(index)}>
                    {isExpanded ? upArrow : downArrow}
                  </TouchableOpacity>
                </View>
                {isExpanded && item.description ? (
                  <Text style={styles.accordiaDescription}>
                    {item.description}
                  </Text>
                ) : null}
              </View>
            );
          })}
        </View>
      </View>
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  heading: TextStyle;
  heading2: TextStyle;
  inputContainer: ViewStyle;
  formInputContainer: ViewStyle;
  questionContainer: ViewStyle;
  input: TextStyle;
  textarea: TextStyle;
  questionForm: ViewStyle;
  accordianContainer: ViewStyle;
  accordiaTitle: TextStyle;
  accordianTitleContainer: ViewStyle;
  accordiaDescription: TextStyle;
  accordian: ViewStyle;
  arrowIcon: ImageStyle;
  errorLabel: TextStyle;
  submitButton: ViewStyle;
  submitButtonText: TextStyle;
  searchButton: ViewStyle;
};

const baseStyles: styleType = {
  container: {
    backgroundImage:
      'linear-gradient(to bottom right, #7366FF 0%, #B961FF 100%)',
    paddingVertical: spacing['8'],
    paddingHorizontal: spacing['14'],
    alignItems: 'center',
    gap: spacing['14'],
  },
  heading: {
    color: 'white',
    fontSize: 54,
    fontWeight: '600',
    textAlign: 'center',
  },
  heading2: {
    color: 'white',
    fontSize: 32,
    fontWeight: '600',
  },

  // upper container
  inputContainer: {
    backgroundColor: 'white',
    borderRadius: corner_radius['rounded-md'],
    height: 54,
    alignItems: 'center',
    width: 750,
    flexDirection: 'row',
    padding: spacing[1],
    gap: spacing[1],
  },

  formInputContainer: {
    height: 54,
    alignItems: 'center',
    width: '100%',
    gap: spacing[1],
  },

  questionContainer: {
    gap: spacing['4'],
    flexDirection: 'row',
    maxWidth: 1280,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },
  input: {
    flex: 1,
    color: '#717998',
    padding: spacing['2'],
    fontSize: spacing['5'],
    fontWeight: '500',
    outline: 'none',
  },
  textarea: {
    flex: 1,
    color: '#717998',
    padding: spacing['2'],
    fontSize: spacing['4'],
    width: '100%',
    fontWeight: '500',
    backgroundColor: 'white',
    borderRadius: corner_radius.rounded,
    outline: 'none',
  },

  questionForm: {
    gap: spacing['4'],
    alignSelf: 'center',
    paddingRight: spacing['16'],
  },
  accordianContainer: {
    gap: spacing['4'],
  },
  accordiaTitle: {
    flex: 1,
    fontSize: 20,
    fontWeight: '600',
    color: colors.palette.brandBlue,
  },
  accordianTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing['1'],
  },
  accordiaDescription: {
    fontSize: 16,
    fontWeight: '500',
    color: '#4A4E5E',
  },
  accordian: {
    backgroundColor: 'white',
    paddingVertical: spacing['2'],
    paddingHorizontal: spacing['4'],
    gap: spacing['4'],

    borderRadius: corner_radius['rounded-md'],
  },

  arrowIcon: {
    width: 14,
    height: 10,
    resizeMode: 'contain',
  },
  errorLabel: {
    color: colors.palette.errorRed,
    alignSelf: 'flex-start',
    fontWeight: '700',
  },
  submitButton: {
    width: 280,
  },
  submitButtonText: {
    fontSize: 18,
  },
  searchButton: {
    width: 150,
  },
};
